
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns:dc": "http://purl.org/dc/elements/1.1/",
    "xmlns:cc": "http://creativecommons.org/ns#",
    "xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    "xmlns:svg": "http://www.w3.org/2000/svg",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    "xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
    "xml:space": "preserve",
    "width": "160",
    "height": "160",
    "version": "1.1",
    "style": "clip-rule:evenodd;fill-rule:evenodd;image-rendering:optimizeQuality;shape-rendering:geometricPrecision;text-rendering:geometricPrecision",
    "viewBox": "0 0 1666.6667 1666.8369",
    "id": "svg38",
    "sodipodi:docname": "cloudian.svg",
    "inkscape:version": "0.92.4 (5da689c313, 2019-01-14)"
  },
  "children": [
    {
      "tag": "metadata",
      "attrsMap": {
        "id": "metadata42"
      },
      "children": [
        {
          "tag": "rdf:RDF",
          "children": [
            {
              "tag": "cc:Work",
              "attrsMap": {
                "rdf:about": ""
              },
              "children": [
                {
                  "tag": "dc:format",
                  "children": [
                    {
                      "text": "image/svg+xml"
                    }
                  ]
                },
                {
                  "tag": "dc:type",
                  "attrsMap": {
                    "rdf:resource": "http://purl.org/dc/dcmitype/StillImage"
                  }
                },
                {
                  "tag": "dc:title"
                }
              ]
            }
          ]
        }
      ]
    },
    {
      "tag": "sodipodi:namedview",
      "attrsMap": {
        "pagecolor": "#ffffff",
        "bordercolor": "#666666",
        "borderopacity": "1",
        "objecttolerance": "10",
        "gridtolerance": "10",
        "guidetolerance": "10",
        "inkscape:pageopacity": "0",
        "inkscape:pageshadow": "2",
        "inkscape:window-width": "1673",
        "inkscape:window-height": "931",
        "id": "namedview40",
        "showgrid": "false",
        "units": "px",
        "inkscape:zoom": "1.11",
        "inkscape:cx": "159.90991",
        "inkscape:cy": "95.225335",
        "inkscape:window-x": "54",
        "inkscape:window-y": "26",
        "inkscape:window-maximized": "0",
        "inkscape:current-layer": "svg38"
      }
    },
    {
      "tag": "defs",
      "attrsMap": {
        "id": "defs4"
      }
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "g4573",
        "transform": "translate(-686.25631,82.403259)"
      },
      "children": [
        {
          "tag": "polygon",
          "attrsMap": {
            "transform": "translate(0,-69.453818)",
            "class": "fil0",
            "points": "1524,293 1524,-5 815,404 1073,553 ",
            "id": "polygon7",
            "style": "fill:#424b53;fill-rule:nonzero"
          }
        },
        {
          "tag": "polygon",
          "attrsMap": {
            "transform": "translate(0,-69.453818)",
            "class": "fil0",
            "points": "1524,814 1726,697 1524,581 1323,697 ",
            "id": "polygon9",
            "style": "fill:#424b53;fill-rule:nonzero"
          }
        },
        {
          "tag": "polygon",
          "attrsMap": {
            "transform": "translate(0,-69.453818)",
            "class": "fil1",
            "points": "1524,814 1524,1047 1726,930 1726,697 ",
            "id": "polygon11",
            "style": "fill:#bfd43f;fill-rule:nonzero"
          }
        },
        {
          "tag": "polygon",
          "attrsMap": {
            "transform": "translate(0,-69.453818)",
            "class": "fil1",
            "points": "2234,404 1976,553 1976,1074 1524,1335 1524,1632 2234,1223 ",
            "id": "polygon13",
            "style": "fill:#bfd43f;fill-rule:nonzero"
          }
        },
        {
          "tag": "polygon",
          "attrsMap": {
            "transform": "translate(0,-69.453818)",
            "class": "fil2",
            "points": "1524,1047 1524,814 1323,697 1323,930 ",
            "id": "polygon15",
            "style": "fill:#969c98;fill-rule:nonzero"
          }
        },
        {
          "tag": "polygon",
          "attrsMap": {
            "transform": "translate(0,-69.453818)",
            "class": "fil2",
            "points": "1073,1074 1073,553 815,404 815,1223 1524,1632 1524,1335 ",
            "id": "polygon17",
            "style": "fill:#969c98;fill-rule:nonzero"
          }
        }
      ]
    }
  ]
})
    }
  